import { StatusSupplierInventoryImportEnum } from "@/main/services/enum/StatusSupplierInventoryImportEnum";
import { getTranslateByKey } from "@/main/services/utils";
import { useStyles } from "./styles";

interface Props {
	status: number;
}

export default function StatusImportHistoryComponent(props: Props) {
	const classes = useStyles();
	const renderColor = () => {
		switch (props.status) {
			case StatusSupplierInventoryImportEnum.Success:
				return "#00cc66";
			case StatusSupplierInventoryImportEnum.Error:
				return "#ff0000";
			case StatusSupplierInventoryImportEnum.Partial:
				return "#ff9900";
			case StatusSupplierInventoryImportEnum.Scheduled:
				return "#0099ff";
			case StatusSupplierInventoryImportEnum.Cancelled:
				return "#949494";
			default:
				return "#00cc66";
		}
	};

	const renderName = () => {
		switch (props.status) {
			case StatusSupplierInventoryImportEnum.Success:
				return getTranslateByKey("supplierInventoryImportStatus.success");
			case StatusSupplierInventoryImportEnum.Error:
				return getTranslateByKey("supplierInventoryImportStatus.error");
			case StatusSupplierInventoryImportEnum.Partial:
				return getTranslateByKey("supplierInventoryImportStatus.partial");
			case StatusSupplierInventoryImportEnum.Scheduled:
				return getTranslateByKey("supplierInventoryImportStatus.scheduled");
			case StatusSupplierInventoryImportEnum.Cancelled:
				return getTranslateByKey("supplierInventoryImportStatus.cancelled");
		}
	};

	return (
		<div
			className={`d-flex align-items-center justify-content-center ${classes.container}`}
			title={renderName()}
			style={{ backgroundColor: renderColor() }}
		>
			<span className={classes.spanContainer}> {renderName()}</span>
		</div>
	);
}
